import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Folder.svg'

export const IconFolder = IconSVG as IconComponent
